import React from 'react';
import Modal from '../util/Modal';
import LoadingSpinner from '../util/LoadingSpinner';
import FadeOutErrorMessage from '../util/FadeOutErrorMessage';
import ValidatedInput from '../util/ValidatedInput';

export default class SaveSearchModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            title: '',
            validTitle: false
        };

        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onChange(name, value) {
        this.setState({
            [ name ]: value
        });
    }

    validateTitle(title) {
        const validTitle = this.props.savedSearchTitles.indexOf(title.trim()) < 0;
        this.setState({ validTitle });
        return validTitle;
    }

    async onSave() {
        this.setState({ error: false });
        await this.props.save(this.state.title);
        this.props.success ? this.onClose() : this.setState({ error: true });
    }

    async onClose() {
        this.props.close();
        this.setState({
            error: false,
            title: '',
            validTitle: false
        });
    }

    render() {
        return (
            <Modal
                modalShowing={this.props.modalShowing}>
                <div className="modal-container" key='warningModal'>
                    <div className="modal save-search-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Save this search</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        <ValidatedInput input={<input type="text"
                            onKeyDown={e => { if (e.key === 'Enter' && this.state.title && this.state.validTitle) this.onSave() }} />}
                            label="Enter a title for this search" name="title" value={this.state.title} onChange={this.onChange}
                            validated={true} showValidationError={true} validate={this.validateTitle.bind(this)}
                            errorMessage="An existing saved search has been found by this title.  Please enter a unique search title." />
                       
                        {this.props.saving ? <LoadingSpinner height="32" alignRight={true} /> :
                            <div className="warning-modal-btns text-right relative">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.onSave}
                                    disabled={!this.state.title || !this.state.validTitle}>Save</button>
                                <FadeOutErrorMessage show={this.state.error} />
                            </div>}

                    </div>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/SaveSearchModal.jsx